























import { Vue, Component, Prop } from "vue-property-decorator";
import logger from "@/configs/logger";
import * as api from "@/lib/api";
import Dialpad from "@/components/Dialpad.vue";

@Component({ components: { Dialpad } })
export default class AddToCall extends Vue {
  @Prop({ required: true }) attributes!: any;

  dialog = false;

  get inAddedCall() {
    return (
      Array.isArray(this.attributes.added_calls_sids) &&
      this.attributes.added_calls_sids.length
    );
  }

  async handleAddToCall(phoneNumber: string, cb = () => {}) {
    try {
      logger("log", phoneNumber);
      if (!phoneNumber) {
        throw new Error("missing phone number");
      }
      await api.addToCall(phoneNumber, `task_attribute/${this.attributes.id}`);
      cb();
    } catch (err) {
      logger("error", "add to call error", err);
      if (err.response.data.error) {
        this.$toasted.error(err.response.data.error).goAway(2000);
      } else {
        this.$toasted.error("Adding phone number to call failed").goAway(2000);
      }
    }
  }

  async removeAddedCall(cb = () => {}) {
    try {
      await api.removeAddedCallFromTask(`task_attribute/${this.attributes.id}`);
      cb();
      logger("info", "successful removed added call from task");
    } catch (err) {
      logger("error", "remove added call error", err);
      if (err.response.data.error) {
        logger("error", "remove added call error", err.response.data.error);
      }
    }
  }
}
